<nav class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
  <a class="navbar-brand col-md-3 col-lg-3 col-xl-2 mr-0 px-3" routerLink="/" routerLinkActive="active" *ngIf="companyInfo">{{ companyInfo.name }}</a>
  <button 
    class="navbar-toggler position-absolute d-md-none collapsed" 
    type="button" 
    data-toggle="collapse" 
    data-target="#sidebarMenu" 
    aria-controls="sidebarMenu" 
    aria-expanded="false" 
    aria-label="Toggle navigation"
    *ngIf="isAuthenticated"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <!--<input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search">-->
  <ul class="navbar-nav px-3">
    <li class="nav-item text-nowrap">
      <button class="nav-link btn btn-link" *ngIf="isAuthenticated" (click)="logout()">Déconnexion</button>
    </li>
  </ul>
</nav>

<div class="container-fluid">
  <div class="row">
    <nav 
      id="sidebarMenu" 
      class="col-md-3 col-lg-3 col-xl-2 bg-light d-md-block sidebar collapse"
      *ngIf="isAuthenticated"
    >
      <div class="sidebar-sticky pt-3">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/system" routerLinkActive="active">
              <span><i class="bi bi-gear"></i></span>
              Système
            </a>
          </li>
          
          <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Achats</span>
          </h6>
          <li class="nav-item">
            <a class="nav-link" routerLink="/purchase/restock" routerLinkActive="active">
              <span><i class="bi bi-box-arrow-in-down"></i></span>
              Réassorts
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/purchase/order" routerLinkActive="active">
              <span><i class="bi bi-truck"></i></span>
              Commandes
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/purchase/invoice" routerLinkActive="active">
              <span><i class="bi bi-receipt"></i></span>
              Factures
            </a>
          </li>

          <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Inventaire</span>
          </h6>
          <li class="nav-item">
            <a class="nav-link" routerLink="/inventory/reception" routerLinkActive="active">
              <span><i class="bi bi-box"></i></span>
              Réceptions
            </a>
            <a class="nav-link" routerLink="/inventory/rma" routerLinkActive="active">
              <span><i class="bi bi-arrow-left-square"></i></span>
              Retours Fournisseurs
            </a>
            <a class="nav-link" routerLink="/inventory/reference" routerLinkActive="active">
              <span><i class="bi bi-book"></i></span>
              Références
            </a>
            <a class="nav-link" routerLink="/inventory/price-change" routerLinkActive="active">
              <span><i class="bi bi-currency-dollar"></i></span>
              Changement de prix
              <span class="badge badge-pill badge-danger" *ngIf="priceChangesCount != 0">{{ priceChangesCount }}</span>
            </a>
            <a class="nav-link" href="/inventory/reception/labels" target="_blank">
              <span><i class="bi bi bi-tags"></i></span>
              Étiquettes
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/inventory/supplier" routerLinkActive="active">
              <span><i class="bi bi-building"></i></span>
              Fournisseurs
            </a>
          </li>

          <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Ventes</span>
          </h6>

          <li class="nav-item">
            <a class="nav-link" routerLink="/sales/gift-card-alerts" routerLinkActive="active">
              <span><i class="bi bi-gift"></i></span>
              Carte cadeaux
              <span class="badge badge-pill badge-danger" *ngIf="giftCardAlerts != 0">{{ giftCardAlerts }}</span>
            </a>
          </li>
          <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Accès rapide</span>
          </h6>
          <li class="nav-item">
            <a class="nav-link" *ngIf="companyInfo" [attr.href]="companyInfo.shopifyAdminUrl" target="_blank">
              <span><img class="shopify" src="/assets/icons/shopify.png"></span>
              Shopify
              <span><i class="bi bi-box-arrow-up-right"></i></span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" [ngClass]="isAuthenticated ? 'col-md-9 ml-sm-auto col-lg-9 col-xl-10 px-md-4' : 'col-12'">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>